import blog from "../../../../assets/SocialMediaPlatforms/blog.svg";
import complaintWebsite from "../../../../assets/SocialMediaPlatforms/complaint-website.svg";
import discussionForums from "../../../../assets/SocialMediaPlatforms/DiscussionForums.svg";
import Facebook from "../../../../assets/SocialMediaPlatforms/facebook.svg";
import GMB from "../../../../assets/SocialMediaPlatforms/gmb.svg";
import Instagram from "../../../../assets/SocialMediaPlatforms/instagram.svg";
import LinkedIn from "../../../../assets/SocialMediaPlatforms/linkedin.svg";
import news from "../../../../assets/SocialMediaPlatforms/News.svg";
import playstore from "../../../../assets/SocialMediaPlatforms/playstore.svg";
import Twitter from "../../../../assets/SocialMediaPlatforms/twitter.svg";
import Youtube from "../../../../assets/SocialMediaPlatforms/Youtube.svg";
import AppStore from "../../../../assets/SocialMediaPlatforms/AppStore.svg";
import Bookingcom from "../../../../assets/SocialMediaPlatforms/Bookingcom.svg";
import ChatBot from "../../../../assets/SocialMediaPlatforms/ChatBot.svg";
import EcomerceWebsites from "../../../../assets/SocialMediaPlatforms/E-comerceWebsites.svg";
import Email from "../../../../assets/SocialMediaPlatforms/Email.svg";
import Expendiacom from "../../../../assets/SocialMediaPlatforms/Expediacom.svg";
import Quora from "../../../../assets/SocialMediaPlatforms/Quora.svg";
import HolidayIQ from "../../../../assets/SocialMediaPlatforms/HolidayIQ.svg";
import TeamBHP from "../../../../assets/SocialMediaPlatforms/TeamBHP.svg";
import TripAdvisor from "../../../../assets/SocialMediaPlatforms/TripAdvisor.svg";
import Whatsapp from "../../../../assets/SocialMediaPlatforms/Whatsapp.svg";
import pinterest from "../../../../assets/SocialMediaPlatforms/pinterest.svg";
import vk from "../../../../assets/SocialMediaPlatforms/VK_Compact.png";
import googlePlus from "../../../../assets/SocialMediaPlatforms/Google_Plus.svg";
import stumbleUpon from "../../../../assets/SocialMediaPlatforms/StumbleUpon_Logo.png";
import Glassdoor from "../../../../assets/SocialMediaPlatforms/glassdoor.svg";
import TiktokIcon from "../../../../assets/SocialMediaPlatforms/TiktokAppIcon.png";
import PantipChannelIcon from "../../../../assets/SocialMediaPlatforms/PantipChannelIcon.png";
import DiscourseIcon from "../../../../assets/SocialMediaPlatforms/discourse.svg";
// new icons for commandcenter campaign screen - brand post widget
import FacebookNew from "../../../../assets/SocialMediaPlatforms/facebook_square.svg";
import TwitterNew from "../../../../assets/SocialMediaPlatforms/twitter_icon.svg";
import InstagramNew from "../../../../assets/SocialMediaPlatforms/instagram_red.svg";
import YoutubeNew from "../../../../assets/SocialMediaPlatforms/youtube_square.svg";
import LinkedInNew from "../../../../assets/SocialMediaPlatforms/linkedin_square.svg";
import OtherChannel from "../../../../assets/SocialMediaPlatforms/others_channel_image.svg";
import yotpoIcon from "../../../../assets/SocialMediaPlatforms/yotpo_icon.svg";
import Sitejabber from "../../../../assets/SocialMediaPlatforms/Sitejabber_icon.svg";
import GBM from "../../../../assets/SocialMediaPlatforms/GBM.svg";
import SurveyLogo from "../../../../assets/SocialMediaPlatforms/QRLogo.svg";
import FacebookDeprecated from "../../../../assets/depricated_widget_image.svg";
import TwitterDeprecated from "../../../../assets/twitter_depricated_image.svg";
import TelegramIcon from "../../../../assets/SocialMediaPlatforms/TelegramIcon.svg";
import PantipIcon from "../../../../assets/SocialMediaPlatforms/pantip_icon.svg";
import ZomatoIcon from "../../../../assets/SocialMediaPlatforms/Zomato.svg";

export const SocialMedialogo = {
  Twitter: Twitter,
  1: Twitter,
  Instagram: Instagram,
  3: Instagram,
  Facebook: Facebook,
  facebook: Facebook,
  2: Facebook,
  Blogs: blog,
  9: blog,
  ComplaintWebsites: complaintWebsite,
  11: complaintWebsite,
  GMB: GMB,
  26: GMB,
  "Google Play Store": playstore,
  GooglePlayStore: playstore,
  7: playstore,
  LinkedIn: LinkedIn,
  linkedin: LinkedIn,
  Linkedin: LinkedIn,
  5: LinkedIn,
  News: news,
  19: news,
  YouTube: Youtube,
  Youtube: Youtube,
  4: Youtube,
  DiscussionForums: discussionForums,
  13: discussionForums,
  "App Store": AppStore,
  AppStore: AppStore,
  30: AppStore,
  "Booking.com": Bookingcom,
  Bookingcom: Bookingcom,
  10: Bookingcom,
  ChatBot: ChatBot,
  29: ChatBot,
  "E-Commerce Websites": EcomerceWebsites,
  "E-commerce websites": EcomerceWebsites,
  ECommerceWebsites: EcomerceWebsites,
  14: EcomerceWebsites,
  Email: Email,
  25: Email,
  Expendiacom: Expendiacom,
  15: Expendiacom,
  HolidayIQ: HolidayIQ,
  16: HolidayIQ,
  TeamBHP: TeamBHP,
  21: TeamBHP,
  TripAdvisor: TripAdvisor,
  22: TripAdvisor,
  Glassdoor: Glassdoor,
  33: Glassdoor,
  WhatsApp: Whatsapp,
  Whatsapp: Whatsapp,
  28: Whatsapp,
  Quora: Quora,
  36: Quora,
  stumbleUpon: stumbleUpon,
  stumbledupon: stumbleUpon,
  googlePlus: googlePlus,
  6: googlePlus,
  gplus: googlePlus,
  vk: vk,
  pinterest: pinterest,
  Glassdoor: Glassdoor,
  Tiktok: TiktokIcon,
  TikTok: TiktokIcon,
  37: TiktokIcon,
  Sitejabber: Sitejabber,
  39: Sitejabber,
  31: DiscourseIcon,
  Discourse: DiscourseIcon,
  "Google Plus": googlePlus,
  "Complaint Websites": complaintWebsite,
  "Discussion Forums": discussionForums,
  "Discussion forums": discussionForums,
  Others: OtherChannel,
  31: DiscourseIcon,
  Discourse: DiscourseIcon,
  "Google Plus": googlePlus,
  "Complaint Websites": complaintWebsite,
  "Discussion Forums": discussionForums,
  Others: OtherChannel,
  Yotpo: yotpoIcon,
  40: yotpoIcon,
  Sitejabber: Sitejabber,
  GBM: GBM,
  41: SurveyLogo,
  Survey: SurveyLogo,
  42: TelegramIcon,
  Telegram: TelegramIcon,
  43: PantipIcon,
  Pantip: PantipIcon,
  Zomato: ZomatoIcon,
  zomato: ZomatoIcon,
  pantip: PantipChannelIcon,
  Pantip: PantipChannelIcon,
  43: PantipChannelIcon,
};

export const SocialMedialogoForBrandPost = {
  Twitter: TwitterNew,
  1: TwitterNew,
  Instagram: InstagramNew,
  3: InstagramNew,
  Facebook: FacebookNew,
  facebook: FacebookNew,
  2: FacebookNew,

  LinkedIn: LinkedInNew,
  linkedin: LinkedInNew,
  5: LinkedInNew,

  YouTube: YoutubeNew,
  Youtube: YoutubeNew,
  4: YoutubeNew,
};

export const SocialMedialogoDeprecated = {
  Twitter: TwitterDeprecated,
  twitter: TwitterDeprecated,
  1: TwitterDeprecated,
  Facebook: FacebookDeprecated,
  facebook: FacebookDeprecated,
  2: FacebookDeprecated,
};
